var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":function($event){$event.preventDefault();return _setup.getNaverToken.apply(null, arguments)}}},[_vm._t("default"),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"naverIdLogin"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }